export const convertArrayToObject = <
  T extends { [key: string | number]: any },
  K extends keyof T,
>(
  array: T[],
  key: K
) => {
  const initialValue = {} as Record<T[K], T>;
  return array.reduce((obj, item) => {
    if (obj[item[key]]) {
      throw new Error(
        `selected key is not unique. value of "${item[key]}" for "${String(
          key
        )}" key is repeated more than once`
      );
    }
    if (!item[key]) {
      throw new Error('selected key is not exist');
    }
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

export const arrayWrap = <T = any>(
  value: T
): T extends Array<any> ? T : [T] => {
  return (Array.isArray(value) ? value : [value]) as any;
};

export function range(start: number, end: number) {
  const list = [];
  for (let i = start; i <= end; i++) {
    list.push(i);
  }
  return list;
}

export function toLowerCaseKeys<T>(obj: T): T {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => toLowerCaseKeys(item)) as unknown as T;
  }

  return Object.keys(obj).reduce((acc, key) => {
    const lowerCaseKey = key.toLowerCase();
    (acc as any)[lowerCaseKey] = toLowerCaseKeys((obj as any)[key]);
    return acc;
  }, {} as T);
}
